import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

export const FeedbackBarContainer = styled.div`
  background-color: ${colors.white};
  width: 100%;
  z-index: 1;
  max-width: ${maxWidth[3]}px;
  margin: 0 auto;
  text-align: center;
  padding: ${gutterWidth}px;
`;

export const FeedbackBarWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    margin: 30px;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StarRatingContainer = styled.div`
  align-self: center;
  display: flex;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    padding-left: 10px;
  }
`;

export const FeedbackBar_Box_1 = styled.div`
  padding-inline: ${gutterWidth}px;
  margin-bottom: ${gutterWidth}px;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding-inline: 0;
    margin-bottom: 0;
  }
`;
